<script setup>
import FormContainer from "@/Pages/Components/FormContainer.vue";
import {watch} from "vue";

const { form } = defineProps({
    form: {
        type: Object,
        default: {}
    }
})

let selectedExperience = null

const isSelected = () => {
    if (form.experience_id === selectedExperience) {
        selectedExperience = form.experience_id;
        updateExperience(form.experience_id);
    } else {
        form.experience_id = null
        form.experience = null
        form.experienceDetails = null
    }
}

const newToFostering1Details = "I’m new to fostering and just want some information";
const newToFostering2Details = "I’m ready to apply to become a foster carer for the first time";
const returningToFosteringDetails = "I have experience in fostering and may want to foster for you";
const transferringDetails = "I’m a current foster carer and want to transfer to you";

const newToFosteringText = "New to fostering";
const returningToFosteringText = "Returning to fostering";
const transferringText = "Transferring from another fostering agency";

const updateExperience = (newValue) => {
    switch (newValue) {
        case '1':
            form.experience = newToFosteringText;
            form.experienceDetails = newToFostering1Details;
            break;
        case '2':
            form.experience = newToFosteringText;
            form.experienceDetails = newToFostering2Details;
            break;
        case '3':
            form.experience = returningToFosteringText;
            form.experienceDetails = returningToFosteringDetails;
            break;
        case '4':
            form.experience = transferringText;
            form.experienceDetails = transferringDetails;
            break;
        default:
            form.experience = null
            form.experienceDetails = null
            break;
    }
}

watch(() => form.experience_id, (newValue, oldValue) => {
    updateExperience(newValue)
});
</script>

<template>
    <FormContainer title="Experience">
        <v-row>
            <v-col cols="12">
                <p tabindex="0">Where are you on your fostering journey?</p>
                <p class="mb-3" tabindex="0"><small>Please select one</small></p>
                <v-radio-group v-model="form.experience_id" color="primary" role="option">
                    <v-radio @click="isSelected()" class="mb-5" color="primary" :label="newToFostering1Details" value="1" aria type="option"/>
                    <v-radio @click="isSelected()" class="mb-5" color="primary" :label="newToFostering2Details" value="2" type="option"/>
                    <v-radio @click="isSelected()" class="mb-5" color="primary" :label="returningToFosteringDetails" value="3"/>
                    <v-radio @click="isSelected()" class="mb-5" color="primary" :label="transferringDetails" value="4"/>
                </v-radio-group>
            </v-col>
        </v-row>
    </FormContainer>
</template>

<style scoped>

</style>
